import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../graphql/types.generated';
export type NotificationsMarkAsReadMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.MarkAsReadInput;
}>;

export type NotificationsMarkAsReadMutationResult = { __typename?: 'Mutation' } & {
  notificationsMarkAsRead?: GraphQLTypes.Maybe<
    { __typename?: 'MarkAsReadPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message'>>>;
    }
  >;
};

export const NotificationsMarkAsReadDocument = gql`
  mutation notificationsMarkAsRead($input: MarkAsReadInput!) {
    notificationsMarkAsRead(input: $input) {
      errors {
        message
      }
    }
  }
`;
